import React from 'react'
import { Row } from 'antd'

interface Props {
	children: any
}

const SimpleLayout = ({ children }: Props) => (
	<div className={'simple-layout'}>
		<Row align='middle' justify='center' className={'h-full'}>
			{children}
		</Row>
	</div>
)

export default SimpleLayout
